window.customChecked = false;
class Size extends HTMLElement {
    constructor(){
        super();
        this.selectedContainer = this.querySelector('.selected_option');
        this.addEventListener('change', function(){
            // console.log(this.querySelector('input:checked').value);
            if(this.selectedContainer)this.selectedContainer.textContent = this.querySelector('input:checked').value;
            if(this.dataset.option == 'size'){
                if(this.querySelector('input:checked').value == 'custom' || this.querySelector('input:checked').value == 'Custom' ){

                    setTimeout(() => {

    if(
        window.customChecked &&
        window.sizeVariant &&
        document.querySelector('.gpo-choicelist input:checked')
    ){

        document.querySelectorAll('.addition-cost').forEach(text => {
            text.textContent = '(+' + window.sizePrice + ')';
        });

        const sizeInput = document.querySelector('input[name^="items[1][id]"]');

        if(sizeInput){
            sizeInput.value = window.sizeVariant;
            sizeInput.setAttribute('value', window.sizeVariant);
        }

        document.querySelectorAll('input[name^="items[1]"]').forEach(input => {
            input.disabled = false;
        });
    }

}, 100);






                    document.querySelector('.size-options.custom').style.display = 'block';
                    document.querySelector('.size-options.custom').querySelectorAll('select').forEach(select => {
                        select.disabled = false;
                    });
                    window.customChecked = true;
                }else {
                    document.querySelector('.size-options.custom').style.display = 'none';
                    document.querySelector('.size-options.custom').querySelectorAll('select').forEach(select => {
                        select.disabled = true;
                    });
                    window.customChecked = false;
                }
            }
            if(this.dataset.option == 'customization' && this.querySelectorAll('input:checked').length == 0){
                document.querySelector('size-option[data-option="customization"]').querySelectorAll('input').forEach(input => {
                    document.querySelectorAll(`img[alt="${input.value}"]`).forEach(img => {
                        img.parentElement.style.display = 'none';
                    }); 
                });

                document.querySelectorAll('.product-gallery__thumbnail[style="display: block;"]')[1].click();
                document.querySelectorAll('.product-gallery__thumbnail[style="display: block;"]')[0].click();
            }
            if(this.dataset.option == 'customization' && this.querySelector('input:checked')){
                if(this.querySelector('input:checked').value == 'custom' || this.querySelector('input:checked').value == 'Add Slits' ){
                    console.log(this.querySelector('input:checked').value);
                }else if(this.querySelector('input:checked').value == 'custom' || this.querySelector('input:checked').value == 'Add Pockets' ){
                    console.log(this.querySelector('input:checked').value);
                }else {

                }

                document.querySelector('size-option[data-option="customization"]').querySelectorAll('input').forEach(input => {
                    document.querySelectorAll(`img[alt="${input.value}"]`).forEach(img => {
                        img.parentElement.style.display = 'none';
                    }); 
                });
                
                if(document.querySelector('size-option[data-option="customization"]').querySelectorAll('input').length > 1){
                    document.querySelectorAll(`img[alt="${document.querySelector('size-option[data-option="customization"]').querySelectorAll('input')[0].value} - ${document.querySelector('size-option[data-option="customization"]').querySelectorAll('input')[1].value}"]`).forEach(img => {
                        img.parentElement.style.display = 'none';
                    }); 
                }
            }
            const FirstOption = document.querySelectorAll('size-option input:checked')[0] ? document.querySelectorAll('size-option input:checked')[0].value : '';
            const SecondOption = document.querySelectorAll('size-option input:checked')[1] ? document.querySelectorAll('size-option input:checked')[1].value : '';
            const thirdOption = document.querySelectorAll('size-option input:checked')[2] ? document.querySelectorAll('size-option input:checked')[2].value : '';
            console.log('first:-' + FirstOption,'second:-' + SecondOption,'third:-' + thirdOption);
            if(FirstOption == 'Custom' && SecondOption == '' && thirdOption == ''){
                //console.log("FirstOption == 'Custom' && SecondOption == '' && thirdOption == ''");
                if(window.sizeVariant && window.sizeVariant != ''){
                    document.querySelectorAll('input[name^="items[1]"]').forEach(input => {
                        input.disabled = false;
                    });
                    document.querySelector('input[name^="items[1][id]"]').value = window.sizeVariant;
                    document.querySelector('input[name^="items[1][id]"]').setAttribute('value', window.sizeVariant);
                    document.querySelectorAll('input[name^="items[2]"]').forEach(input => {
                        input.disabled = true;
                    });
                    document.querySelectorAll('.addition-cost').forEach(text => {
                        text.textContent = '(+' + window.sizePrice +')';
                    });
                }
            }else if(FirstOption != 'Custom' && SecondOption == window.slitVariantName && thirdOption == '') {
                if(document.querySelector(`.product-gallery__thumbnail img[alt="${SecondOption}"]`)){
                    document.querySelectorAll(`img[alt="${SecondOption}"]`).forEach(img => {
                        img.parentElement.style.display = 'block';
                    });
                    document.querySelector(`.product-gallery__thumbnail img[alt="${SecondOption}"]`).parentElement.click();
                }
                //console.log("FirstOption != 'Custom' && SecondOption == 'Add Slits' && thirdOption == ''");
                if(window.slitVariant && window.slitVariant != ''){
                    document.querySelectorAll('input[name^="items[1]"]').forEach(input => {
                        input.disabled = false;
                    });
                    document.querySelector('input[name^="items[1][id]"]').value = window.slitVariant;
                    document.querySelector('input[name^="items[1][id]"]').setAttribute('value', window.slitVariant);
                    document.querySelectorAll('.addition-cost').forEach(text => {
                        text.textContent = '(+' + window.slitPrice +')';
                    });
                    document.querySelectorAll('input[name^="items[2]"]').forEach(input => {
                        input.disabled = true;
                    });
                    document.querySelectorAll('input[name^="items[3]"]').forEach(input => {
                        input.disabled = true;
                    });
                }else {
                    document.querySelectorAll('input[name^="items[1]"]').forEach(input => {
                        input.disabled = true;
                    });
                    document.querySelectorAll('input[name^="items[2]"]').forEach(input => {
                        input.disabled = true;
                    });
                    document.querySelectorAll('input[name^="items[3]"]').forEach(input => {
                        input.disabled = true;
                    });
                }
            }else if(FirstOption != 'Custom' && SecondOption == window.pocketVariantName && thirdOption == '') {
                if(document.querySelector(`.product-gallery__thumbnail img[alt="${SecondOption}"]`)){
                    document.querySelectorAll(`img[alt="${SecondOption}"]`).forEach(img => {
                        img.parentElement.style.display = 'block';
                    });
                    document.querySelector(`.product-gallery__thumbnail img[alt="${SecondOption}"]`).parentElement.click();
                }
                //console.log("FirstOption != 'Custom' && thirdOption == 'Add Pockets' && SecondOption == ''");
                if(window.pocketVariant && window.pocketVariant != ''){
                    document.querySelectorAll('input[name^="items[1]"]').forEach(input => {
                        input.disabled = false;
                    });
                    document.querySelector('input[name^="items[1][id]"]').value = window.pocketVariant;
                    document.querySelector('input[name^="items[1][id]"]').setAttribute('value', window.pocketVariant);
                    document.querySelectorAll('.addition-cost').forEach(text => {
                        text.textContent = '(+' + window.pocketPrice +')';
                    });
                    document.querySelectorAll('input[name^="items[2]"]').forEach(input => {
                        input.disabled = true;
                    });
                    document.querySelectorAll('input[name^="items[3]"]').forEach(input => {
                        input.disabled = true;
                    });
                }else {
                    document.querySelectorAll('input[name^="items[1]"]').forEach(input => {
                        input.disabled = true;
                    });
                    document.querySelectorAll('input[name^="items[2]"]').forEach(input => {
                        input.disabled = true;
                    });
                    document.querySelectorAll('input[name^="items[3]"]').forEach(input => {
                        input.disabled = true;
                    });
                }
            }else if(FirstOption == 'Custom' && SecondOption == window.slitVariantName && thirdOption == ''){
                if(document.querySelector(`.product-gallery__thumbnail img[alt="${SecondOption}"]`)){
                    document.querySelectorAll(`img[alt="${SecondOption}"]`).forEach(img => {
                        img.parentElement.style.display = 'block';
                    });
                    document.querySelector(`.product-gallery__thumbnail img[alt="${SecondOption}"]`).parentElement.click();
                }
                //console.log("FirstOption == 'Custom' && SecondOption == 'Add Slits'");
                if(window.slitVariant && window.slitVariant != ''){
                    document.querySelectorAll('input[name^="items[1]"]').forEach(input => {
                        input.disabled = false;
                    });
                    document.querySelectorAll('input[name^="items[2]"]').forEach(input => {
                        input.disabled = false;
                    });
                    document.querySelector('input[name^="items[1][id]"]').value = window.sizeVariant;
                    document.querySelector('input[name^="items[1][id]"]').setAttribute('value', window.sizeVariant);
                    document.querySelector('input[name^="items[2][id]"]').value = window.slitVariant;
                    document.querySelector('input[name^="items[2][id]"]').setAttribute('value', window.slitVariant);
                    document.querySelectorAll('.addition-cost').forEach(text => {
                        text.textContent = '(+' + window.sizeSlitPrice +')';
                    });
                    document.querySelectorAll('input[name^="items[3]"]').forEach(input => {
                        input.disabled = true;
                    });
                }else {
                    document.querySelectorAll('input[name^="items[1]"]').forEach(input => {
                        input.disabled = false;
                    });
                    document.querySelector('input[name^="items[1][id]"]').value = window.sizeVariant;
                    document.querySelector('input[name^="items[1][id]"]').setAttribute('value', window.sizeVariant);
                    document.querySelectorAll('.addition-cost').forEach(text => {
                        text.textContent = '(+' + window.sizePrice +')';
                    });
                    document.querySelectorAll('input[name^="items[2]"]').forEach(input => {
                        input.disabled = true;
                    });
                    document.querySelectorAll('input[name^="items[3]"]').forEach(input => {
                        input.disabled = true;
                    });
                }
            }else if(FirstOption == 'Custom' && SecondOption == window.pocketVariantName && thirdOption == ''){
                if(document.querySelector(`.product-gallery__thumbnail img[alt="${SecondOption}"]`)){
                    document.querySelectorAll(`img[alt="${SecondOption}"]`).forEach(img => {
                        img.parentElement.style.display = 'block';
                    });
                    document.querySelector(`.product-gallery__thumbnail img[alt="${SecondOption}"]`).parentElement.click();
                }
                //console.log("FirstOption == 'Custom' && thirdOption == 'Add Pockets'");
                if(window.pocketVariant && window.pocketVariant != ''){
                    document.querySelectorAll('input[name^="items[1]"]').forEach(input => {
                        input.disabled = false;
                    });
                    document.querySelectorAll('input[name^="items[2]"]').forEach(input => {
                        input.disabled = false;
                    });
                    document.querySelector('input[name^="items[1][id]"]').value = window.sizeVariant;
                    document.querySelector('input[name^="items[1][id]"]').setAttribute('value', window.sizeVariant);
                    document.querySelector('input[name^="items[2][id]"]').value = window.pocketVariant;
                    document.querySelector('input[name^="items[2][id]"]').setAttribute('value', window.pocketVariant);
                    document.querySelectorAll('.addition-cost').forEach(text => {
                        text.textContent = '(+' + window.sizePocketPrice +')';
                    });
                    document.querySelectorAll('input[name^="items[3]"]').forEach(input => {
                        input.disabled = true;
                    });
                }else {
                        document.querySelectorAll('input[name^="items[1]"]').forEach(input => {
                            input.disabled = false;
                        });
                        document.querySelector('input[name^="items[1][id]"]').value = window.sizeVariant;
                        document.querySelector('input[name^="items[1][id]"]').setAttribute('value', window.sizeVariant);
                        document.querySelectorAll('.addition-cost').forEach(text => {
                            text.textContent = '(+' + window.sizePrice +')';
                        });
                        document.querySelectorAll('input[name^="items[2]"]').forEach(input => {
                            input.disabled = true;
                        });
                        document.querySelectorAll('input[name^="items[3]"]').forEach(input => {
                            input.disabled = true;
                        });
                }
            }else if(FirstOption == 'Custom' && SecondOption == window.slitVariantName  && thirdOption == window.pocketVariantName){
                if(document.querySelector(`.product-gallery__thumbnail img[alt="${SecondOption} - ${thirdOption}"]`)){
                    document.querySelectorAll(`img[alt="${SecondOption} - ${thirdOption}"]`).forEach(img => {
                        img.parentElement.style.display = 'block';
                    });
                    document.querySelector(`.product-gallery__thumbnail img[alt="${SecondOption} - ${thirdOption}"]`).parentElement.click();
                }
                //console.log("FirstOption == 'Custom' && SecondOption == 'Add Slits'  && thirdOption == 'Add Pockets'");
                document.querySelectorAll('input[name^="items[1]"]').forEach(input => {
                    input.disabled = false;
                });
                document.querySelectorAll('input[name^="items[2]"]').forEach(input => {
                    input.disabled = false;
                });
                document.querySelectorAll('input[name^="items[3]"]').forEach(input => {
                    input.disabled = false;
                });
                document.querySelector('input[name^="items[1][id]"]').value = window.sizeVariant;
                document.querySelector('input[name^="items[1][id]"]').setAttribute('value', window.sizeVariant);
                document.querySelector('input[name^="items[2][id]"]').value = window.slitVariant;
                document.querySelector('input[name^="items[2][id]"]').setAttribute('value', window.slitVariant);
                document.querySelector('input[name^="items[3][id]"]').value = window.pocketVariant;
                document.querySelector('input[name^="items[3][id]"]').setAttribute('value', window.pocketVariant);
                document.querySelectorAll('.addition-cost').forEach(text => {
                    text.textContent = '(+' + window.sizeSlitPocketPrice +')';
                });
            }else if(FirstOption != 'Custom' && thirdOption == window.pocketVariantName && SecondOption == window.slitVariantName) {
                if(document.querySelector(`.product-gallery__thumbnail img[alt="${SecondOption} - ${thirdOption}"]`)){
                    document.querySelectorAll(`img[alt="${SecondOption} - ${thirdOption}"]`).forEach(img => {
                        img.parentElement.style.display = 'block';
                    }); 
                    document.querySelector(`.product-gallery__thumbnail img[alt="${SecondOption} - ${thirdOption}"]`).parentElement.click();
                }
                //console.log("FirstOption != 'Custom' && thirdOption == 'Add Pockets' && SecondOption == 'Add Slits'");
                document.querySelectorAll('input[name^="items[1]"]').forEach(input => {
                    input.disabled = false;
                });
                document.querySelectorAll('input[name^="items[2]"]').forEach(input => {
                    input.disabled = false;
                });
                document.querySelector('input[name^="items[1][id]"]').value = window.slitVariant;
                document.querySelector('input[name^="items[1][id]"]').setAttribute('value', window.slitVariant);
                document.querySelector('input[name^="items[2][id]"]').value = window.pocketVariant;
                document.querySelector('input[name^="items[2][id]"]').setAttribute('value', window.pocketVariant);
                document.querySelectorAll('.addition-cost').forEach(text => {
                    text.textContent = '(+' + window.sizePocketPrice +')';
                });
                document.querySelectorAll('input[name^="items[3]"]').forEach(input => {
                    input.disabled = true;
                });
            }else {
                console.log("else");
                document.querySelectorAll('input[name^="items[1]"]').forEach(input => {
                    input.disabled = true;
                });
                document.querySelectorAll('input[name^="items[2]"]').forEach(input => {
                    input.disabled = true;
                });
                document.querySelectorAll('input[name^="items[3]"]').forEach(input => {
                    input.disabled = true;
                });
                document.querySelectorAll('.addition-cost').forEach(text => {
                    text.textContent = '';
                });
            }
        })
    }
}

customElements.define('size-option', Size);
// console.log(Size);

function checkCondition(form) {
    var checked = false;

    document.querySelectorAll(".variant-picker__option-values label.customisationbox").forEach(function(button){
        if (button.previousElementSibling.checked) {
            checked = true;
        }
    });
    setTimeout(() => {
        if(form.querySelector('#terms_check').checked == true || !checked){
            document.querySelector('buy-buttons button').disabled = false;
        }else {
            document.querySelector('buy-buttons button').disabled = true;
        }
    },500);
}

function showcheckboxes(){
    var checked = false;
    document.querySelectorAll(".variant-picker__option-values label.customisationbox").forEach(function(button){
        if (button.previousElementSibling.checked) {
            checked = true;
        }
    });

    if (checked) {
        document.querySelector(".terms").classList.remove("display_none");
    }
    else
    {
        document.querySelector(".terms").classList.add("display_none");
    }

    var form = document.querySelector(".shopify-product-form");    
    checkCondition(form);
}

document.querySelectorAll(".variant-picker__option-values label.customisationbox").forEach(function(btn){
    btn.addEventListener("click", function(){
        setTimeout(() => {
            showcheckboxes()
        }, 500);
    })
})

document.querySelectorAll(".nocustomization").forEach(function(btn){
    btn.addEventListener("click", function(){
        setTimeout(() => {
            showcheckboxes()
        }, 500);
    });
});

document.querySelector('input[name="id"]').name = 'items[0][id]';
document.querySelector('input[name="quantity"]').name = 'items[0][quantity]';
const input = document.createElement('input');
input.name = 'items[0][properties][bundle_id]';
input.value = '';
input.type = 'hidden';
input.classList.add('bundle_id');
document.querySelector('.shopify-product-form').prepend(input);

const selling_input = document.createElement('input');
selling_input.name = 'items[0][selling_plan]';
selling_input.value = '';
selling_input.disabled = true;
selling_input.type = 'hidden';
document.querySelector('.shopify-product-form').prepend(selling_input);

const propertiesData = document.querySelector('.product-info').querySelectorAll("input[name^='properties']:checked");

propertiesData.forEach(input => {
    const name = input.name.split('[')[1].split(']')[0];
    properties[name] = input.value;
})

const bundle_id = crypto.randomUUID();
document.querySelectorAll('.bundle_id').forEach((input, index) => {
    input.value = bundle_id;
    if(index == 0){
        input.disabled = false;
    }
});

const subscription = setInterval(function(){
    if(document.querySelector('.paywhirl-plan-selector-plan')){
        clearInterval(subscription);
        console.log('FOUND SUB');
        document.querySelector('input[name="items[0][selling_plan]"]').disabled = false;
        document.querySelector('input[name="items[0][selling_plan]"]').value = document.querySelector('.paywhirl-plan-selector-plan select').value;
        document.querySelector('.paywhirl-plan-selector-plan select').addEventListener('change', function(){
            document.querySelector('input[name="items[0][selling_plan]"]').value = this.value;
        });

    }
});
// Change "Floor" label to "Hollow to Hem"
//document.querySelector('label[for="custom_floor"]').innerText = "Hollow to Hem";

// Adjust "Hollow to Hem" dropdown


// Move "Neckline to Hem" dropdown to correct position
var necklineToHemDropdown = document.getElementById("custom_height");
necklineToHemDropdown.parentNode.parentNode.insertBefore(necklineToHemDropdown.parentNode, document.querySelector('label[for="custom_floor"]').parentNode);

// Adjust "Hips" dropdown


// Make "I Confirm" text appear in checkout
document.querySelector(".size-options.custom").addEventListener("change", function() {
    var confirmationText = document.createElement("p");
    confirmationText.innerText = "I Confirm";
    var checkoutForm = document.getElementById("checkout-form");
    checkoutForm.appendChild(confirmationText);
});

window.addEventListener('quantity-updated', function(e){
  setTimeout(() => {
    const qty = e.detail.value;
    document.querySelector('input[name^="items[1][quantity]"]').value = qty;
    document.querySelector('input[name^="items[2][quantity]"]').value = qty;
    document.querySelector('input[name^="items[3][quantity]"]').value = qty;
  });
})









document.addEventListener('change', function(e){

    if(!e.target.closest('.gpo-choicelist')) return;

    if(window.customChecked && window.sizeVariant){

        document.querySelectorAll('.addition-cost').forEach(text => {
            text.textContent = '(+' + window.sizePrice + ')';
        });

        const sizeInput = document.querySelector('input[name^="items[1][id]"]');

        if(sizeInput){
            sizeInput.value = window.sizeVariant;
        }

        document.querySelectorAll('input[name^="items[1]"]').forEach(input => {
            input.disabled = false;
        });
    }
});